<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  components: {},
  created() {
    // クラスモ判定
    const isClasmo = process.env.VUE_APP_CLASMO
    const mode = isClasmo === 'true' ? 'clasmo' : '3nosuke'
    this.$store.commit('AppEnv/setMode', mode)
    this.setFavicon(mode)
  },
  mounted() {
    this.createPageTitle(this.$route)
  },
  watch: {
    $route(to) {
      this.createPageTitle(to)
    },
  },
  methods: {
    // タイトルをセット
    createPageTitle(routeObj) {
      const mode = this.$store.getters['AppEnv/getMode']
      let siteTitle = mode === 'clasmo' ? 'CPS3 - ' : '3之助 - '
      if (routeObj.meta.title) siteTitle += routeObj.meta.title
      document.title = siteTitle
    },
    // modeに合わせてfaviconをセットする
    setFavicon(mode) {
      const link = document.querySelector("link[rel*='icon']")
      if (mode === 'clasmo') {
        link.href = `${process.env.VUE_APP_URL}/assets/img/clasmo_favicon.ico`
      } else {
        link.href = `${process.env.VUE_APP_URL}/assets/img/3nosuke_favicon.ico`
      }
    },
  },
}
</script>
<style lang="scss">
#app {
  font-family: 'メイリオ', 'Meiryo', 'Hiragino Kaku Gothic ProN', 'ヒラギノ角ゴ ProN W3', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #515a6e;
}
</style>
